import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM3.6 24C3.6 35.2666 12.7334 44.4 24 44.4C35.2666 44.4 44.4 35.2666 44.4 24C44.4 12.7334 35.2666 3.6 24 3.6C12.7334 3.6 3.6 12.7334 3.6 24Z",
      fill: "#F2F2F2",
      id: "progress-circle"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 0C28.2086 0 32.3432 1.10671 35.9891 3.20911C39.635 5.31151 42.6639 8.33567 44.772 11.9782C46.8802 15.6208 47.9934 19.7537 48 23.9623C48.0066 28.1709 46.9064 32.3073 44.8097 35.9564L41.6882 34.163C43.4704 31.0612 44.4056 27.5453 44.4 23.968C44.3944 20.3906 43.4481 16.8777 41.6562 13.7815C39.8643 10.6853 37.2897 8.11478 34.1908 6.32774C31.0918 4.5407 27.5773 3.6 24 3.6V0Z",
      fill: "#439f7f"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.417 29V20.6533H17.3828L14.8057 22.4854V20.9814L17.4033 19.1357H18.9141V29H17.417ZM21.8672 31.1055H20.5547L24.0547 19.1357H25.3672L21.8672 31.1055ZM28.2793 24.5361V23.333H29.4688C30.5352 23.333 31.2666 22.6631 31.2666 21.7334C31.2666 20.8174 30.6377 20.209 29.4688 20.209C28.4023 20.209 27.6914 20.8242 27.6025 21.7949H26.1602C26.2764 20.0654 27.582 18.9512 29.5371 18.9512C31.4033 18.9512 32.7637 20.0107 32.7637 21.5283C32.7637 22.7588 31.957 23.6406 30.7334 23.8594V23.8867C32.2168 23.9893 33.1738 24.8984 33.1738 26.2793C33.1738 28.002 31.6084 29.1846 29.5508 29.1846C27.4248 29.1846 26.0576 28.0156 25.9619 26.3135H27.4316C27.5273 27.2568 28.3066 27.9062 29.5508 27.9062C30.7539 27.9062 31.6152 27.2227 31.6152 26.2588C31.6152 25.1924 30.8086 24.5361 29.5098 24.5361H28.2793Z",
      fill: "#1C2026",
      id: "progress-digits"
    }, null, -1)
  ])))
}
export default { render: render }